import React, { Component } from "react";
import { useState, useEffect } from 'react'
import store from "@/redux/store";

import { useNavigate, Link } from "react-router-dom";
import { useForm, SubmitHandler, Controller } from "react-hook-form"

export function BaseForm({...props}) {
    const [selectedTab, setSelectedTab] = useState(1)
      const { register, handleSubmit, watch, reset, control, setValue, getValues, formState, formState: { isSubmitSuccessful } } = useForm({
      defaultValues: props.data
    })
    
        const form = {
            register: register,
            getValues: getValues,
            setValue: setValue,
        }
  const onSaveWrapped = (data) => {
    event.preventDefault();
    event.stopPropagation();
    
    if(props.onSaveHandler) {
        props.onSaveHandler(data);
    }
      
    return false;
  };

var newChildren = React.Children.map(props.children, function(child) {
    if(child) {
        return React.cloneElement(child, { register: register, form: form })
    }
    return child;
  return React.cloneElement(child, { foo: true })
});
    if(newChildren.length == 0) {
        return (<></>);
    }
  return (
    <>
    <form className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2" onSubmit={handleSubmit(onSaveWrapped)}>

          <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
            <Link to={"../"} type="button" className="text-sm font-semibold leading-6 text-gray-900">
              Annuleren
            </Link>
            <button
              type="submit"
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Opslaan
            </button>
          </div>
          { newChildren }
    </form>
    </>
    );
  }
    